export default __webpack_public_path__ + "static/assets/7927217c728d42ffa0bb3d7e6e5d924d.svg";